import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { CloseButton } from '@gem/call/CallView/Shared/CloseButton/CloseButton';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';
import { IcBack32Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import styles from './MembersPanelHeader.styles.m.css';

interface IMembersPanelHeaderProps {
  call: Call;
}

export const MembersPanelHeader: FC<IMembersPanelHeaderProps> = observer(({ call }) => {
  const { t } = useTranslation();

  const hideMembers = useCallback(() => {
    call.viewState.hideMembers();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <CloseButton
          Icon={IcBack32Icon}
          onClick={hideMembers}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{t('common_participants')}</div>
        <div className={styles.description}>
          {call.uiFeatures.participantsControlType === ParticipantsControlType.WithMaxNumber
            ? t('calls_users_on_call', {
                0: call?.members.memberDevicesOnCallList.length || 0,
                1: call?.members.memberList.length || 0,
              })
            : null}
          {call.uiFeatures.participantsControlType === ParticipantsControlType.TotalNumber ||
          call.isUnauthorizedCall
            ? t('calls_participants_on_call_section_name', {
                0: call?.members.memberDevicesOnCallList.length || 0,
              })
            : null}
        </div>
      </div>
    </div>
  );
});
